import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6.826 9.914"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "m4.84 7.877 1.37.007a.58.58 0 0 1 .577.583l-.004.87a.58.58 0 0 1-.583.577l-.79-.004a.58.58 0 0 1-.577-.583zM5.46 0l.79.004a.58.58 0 0 1 .577.583l-.004.87a.58.58 0 0 1-.583.577l-1.37-.007.007-1.45A.58.58 0 0 1 5.46 0zM1.94 5.965.57 5.958a.58.58 0 0 1-.577-.583l.004-.88a.58.58 0 0 1 .583-.577l1.37.007-.01 2.03z" }),
      _createElementVNode("path", { d: "m1.95 5.957 2.32.012a.58.58 0 0 1 .577.582l-.007 1.37-2.32-.011a.58.58 0 0 1-.577-.583zM2.55 2.01l2.32.012-.007 1.37a.58.58 0 0 1-.583.577l-2.32-.012.007-1.37a.58.58 0 0 1 .583-.577z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "left-chevron"}) } }